import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SHOULD_PRESET_COMPANY_CLAIMGROUP_FORM_FILEDS } from '@rd-web-markets/market/dist/constants';
const defaultMd = {
  label: {
    offset: 0,
    span: 7
  },
  field: {
    offset: 0,
    span: 5
  }
};
const YesOrNoFormField = _ref => {
  var _ref2, _formName$replace;
  let {
    labelText,
    disabled,
    formName,
    trueLabel = 'yes',
    falseLabel = 'no',
    checkedField,
    onChange,
    onChangeParams,
    md = defaultMd,
    dataTestId,
    renderLabel = true
  } = _ref;
  const {
    t
  } = useTranslation();
  const baseTestId = (_ref2 = dataTestId !== null && dataTestId !== void 0 ? dataTestId : formName === null || formName === void 0 || (_formName$replace = formName.replace) === null || _formName$replace === void 0 ? void 0 : _formName$replace.call(formName, /\./g, '_')) !== null && _ref2 !== void 0 ? _ref2 : 'yes_no_form_field';
  const trueTestId = "".concat(baseTestId, "_trueButton");
  const falseTestId = "".concat(baseTestId, "_falseButton");
  return /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, renderLabel && /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: md.label
  }, labelText), /*#__PURE__*/React.createElement(Col, {
    md: md.field
  }, /*#__PURE__*/React.createElement(Form.Check, {
    type: "radio",
    inline: true,
    disabled: disabled,
    label: t(trueLabel),
    name: formName,
    value: true,
    checked: checkedField === true,
    onChange: e => onChangeParams ? onChange(e, ...onChangeParams) : onChange(e),
    "data-testid": trueTestId
  }), /*#__PURE__*/React.createElement(Form.Check, {
    type: "radio",
    inline: true,
    disabled: disabled,
    label: t(falseLabel),
    value: "false",
    name: formName,
    checked: SHOULD_PRESET_COMPANY_CLAIMGROUP_FORM_FILEDS ? checkedField === false || checkedField === undefined : checkedField === false,
    onChange: e => onChangeParams ? onChange(e, ...onChangeParams) : onChange(e),
    "data-testid": falseTestId
  })));
};
export default YesOrNoFormField;